document.addEventListener("DOMContentLoaded", function () {
  function trackFreeGiftProductClick(productId, productTitle, sectionId) {
    if (typeof gtag !== "undefined") {
      gtag("event", "free_gift_product_click", {
        event_category: "Free Gift Experiment",
        event_label: productTitle,
        product_id: productId,
        section_id: sectionId,
        custom_parameter: "v1_free_gift_tag",
      });
    }
    if (typeof fbq !== "undefined") {
      fbq("trackCustom", "FreeGiftProductClick", {
        product_id: productId,
        product_title: productTitle,
        section_id: sectionId,
        experiment_variant: "v1_free_gift_tag",
      });
    }
  }

  function trackFreeGiftProductImpression(productId, productTitle, sectionId) {
    if (typeof gtag !== "undefined") {
      gtag("event", "free_gift_product_impression", {
        event_category: "Free Gift Experiment",
        event_label: productTitle,
        product_id: productId,
        section_id: sectionId,
        custom_parameter: "v1_free_gift_tag",
      });
    }
    if (typeof fbq !== "undefined") {
      fbq("trackCustom", "FreeGiftProductImpression", {
        product_id: productId,
        product_title: productTitle,
        section_id: sectionId,
        experiment_variant: "v1_free_gift_tag",
      });
    }
  }

  function isProductEligible(productTitle, productPrice) {
    if (productPrice >= 95) {
      return true;
    }
    const qualifyingProducts = [
      "GUT RENEW Formula - Original (10 servings)",
      "Original Value Size GUT RENEW Formula (30 servings)",
      "GUT RENEW 30-Day Challenge Basic Kit - Original",
      "GUT RENEW 30-Day Challenge Essential Kit - Original",
      "Original Value Size GUT RENEW Formula 2-Pack (30 servings each)",
      "Value Size GUT RENEW Formula - Chocolate (30 servings)",
      "Chocolate Value Size GUT RENEW Formula 2-Pack (30 servings each)",
      "Chocolate & Original Value Size GUT RENEW Formula 2-Pack (30 servings each)",
      "GUT RENEW Formula - Chocolate (10 servings)",
      "GUT RENEW 30-Day Challenge Essential Kit - Chocolate",
      "GUT RENEW 30-Day Challenge Essential Kit - 1 Original + 1 Chocolate",
      "GUT RENEW 30-Day Challenge Basic Kit - Chocolate",
      "GUT RENEW 30-Day Challenge Basic Kit - 1 Original + 1 Chocolate",
      "GUT RENEW 7-Piece Mega Kit",
      "2-Piece Essential GUT HEALTH KIT",
      "Value Size GUT RENEW Formula + Chocolate Collagen Custard 3-Piece Kit - Original",
      "Value Size GUT RENEW Formula + Chocolate Collagen Custard 3-Piece Kit - Chocolate",
      "3-Piece GUT RENEW & Chocolate Collagen Custard Kit - Original",
      "Value Size GUT RENEW Formula & Chocolate Collagen Custard Kit",
      "6-Piece GUT RENEW Formula (10 servings) & Chocolate Collagen Custard Kit - Original",
      "6-Piece GUT RENEW Formula (10 servings) & Chocolate Collagen Custard Kit - Chocolate",
      "3-Piece GUT RENEW Formula + Chocolate Collagen Custard",
      "GUT RENEW Prebiotic, Advanced Probiotic, and Postbiotic Gummies Combo",
      "BOGO Trial Offer - Original Value Size GUT RENEW Formula",
    ];

    return qualifyingProducts.includes(productTitle);
  }

  function addFreeGiftTagsToPageFly() {
    if (window.location.pathname.includes("/products/")) {
      return;
    }
    const productCards = document.querySelectorAll(
      '[data-pf-type="Product"], .pf-product-card, [class*="product"]:not(.snize-product)'
    );

    productCards.forEach((card) => {
      if (card.querySelector(".free-gift-tag")) return;
      const titleElement = card.querySelector(
        'h1, h2, h3, h4, h5, h6, [class*="title"], [class*="name"]'
      );
      const priceElement = card.querySelector(
        '[class*="price"], [data-pf-type="Price"]'
      );

      if (titleElement) {
        const productTitle = titleElement.textContent.trim();
        let productPrice = 0;

        if (priceElement) {
          const priceText = priceElement.textContent.replace(/[^0-9.]/g, "");
          productPrice = parseFloat(priceText) || 0;
        }

        if (isProductEligible(productTitle, productPrice)) {
          const tag = document.createElement("div");
          tag.className = "free-gift-tag free-gift-tag--top-right";
          tag.style.cssText = `
            position: absolute;
            top: 8px;
            right: 8px;
            z-index: 10;
            background: #80bd01;
            color: white;
            padding: 4px 8px;
            font-size: 12px;
            font-weight: 600;
            text-transform: uppercase;
            border-radius: 4px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          `;
          tag.innerHTML = `
            <div style="display: flex; align-items: center; gap: 4px;">
              <span style="display: inline-flex; align-items: center; flex-shrink: 0;">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 0 0-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM15 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"/>
                </svg>
              </span>
              <span style="line-height: 1; white-space: nowrap;">Free Gift with Purchase</span>
            </div>
          `;

          tag.dataset.productTitle = productTitle;
          tag.dataset.productPrice = productPrice;

          const imageContainer =
            card.querySelector('[data-pf-type="Image"], img').closest("div") ||
            card;
          if (imageContainer.style.position !== "relative") {
            imageContainer.style.position = "relative";
          }
          imageContainer.appendChild(tag);
        }
      }
    });
  }

  function initializeFreeGiftTracking() {
    const freeGiftTags = document.querySelectorAll(
      ".free-gift-tag:not([data-tracked])"
    );

    freeGiftTags.forEach(function (tag) {
      // Mark as tracked to avoid duplicate tracking
      tag.setAttribute("data-tracked", "true");

      const productCard = tag.closest(
        '.card-wrapper, .product-card-wrapper, [data-pf-type="Product"], .pf-product-card, [class*="product"]:not(.snize-product)'
      );

      if (productCard) {
        let productTitleText = tag.dataset.productTitle;
        let productId = "";
        let sectionId = "";

        const productLink = productCard.querySelector(
          'a[id*="CardLink"], a[id*="StandardCardNoMediaLink"]'
        );
        const productTitle = productCard.querySelector(".card__heading a");

        if (productLink && productTitle) {
          productTitleText = productTitle.textContent.trim();
          const linkId = productLink.getAttribute("id");
          const idParts = linkId.split("-");
          sectionId = idParts.length > 1 ? idParts[1] : "";
          productId = idParts.length > 2 ? idParts[2] : "";
        } else {
          productId = productTitleText
            ? productTitleText.replace(/[^a-zA-Z0-9]/g, "").toLowerCase()
            : "unknown";
          sectionId = "pagefly";
        }

        trackFreeGiftProductImpression(productId, productTitleText, sectionId);

        productCard.addEventListener("click", function (event) {
          if (!event.target.closest("button, .quick-add")) {
            trackFreeGiftProductClick(productId, productTitleText, sectionId);
          }
        });
      }
    });
  }

  addFreeGiftTagsToPageFly();
  initializeFreeGiftTracking();
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            addFreeGiftTagsToPageFly();
            const newFreeGiftTags = node.querySelectorAll
              ? node.querySelectorAll(".free-gift-tag")
              : [];
            if (
              newFreeGiftTags.length > 0 ||
              node.classList.contains("free-gift-tag")
            ) {
              initializeFreeGiftTracking();
            }
          }
        });
      }
    });
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
